import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormSelectChoice, FormFieldComponentProps, VerificationServiceProps } from '../../../lib/types/types';
import { TypeaheadComponent } from '../../FormInputs/Typeahead/TypeaheadComponent';

const CompanyComponent = ({
    onChange,
    value,
    isErrored,
    verificationService,
    placeholder = '',
}: FormFieldComponentProps & VerificationServiceProps) => {
    const programId = verificationService.programId;

    return (
        <div className="sid-field sid-company-id">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-company">
                <div className={`sid-field__label sid-field__label--required sid-l-space-btm-sm ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                    <FormattedHTMLMessage
                        id="company"
                        defaultMessage="Company"
                    />
                </div>
            </label>

            <TypeaheadComponent
                className={isErrored ? 'sid-text-input--error' : ''}
                countryCode={'US'}
                minimumSearchValueLength={3}
                onChange={ (choice: FormSelectChoice) => onChange(choice) }
                placeholder={placeholder}
                programId={programId}
                value={value}
                inputHtmlId="sid-company"
                openOrgSearchEnabled={verificationService.programTheme.openOrgSearchEnabled}
                orgSearchUrl={verificationService.programTheme.config.orgSearchUrl}
            />
            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidOrganization"
                            defaultMessage="You must select an organization from the list"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export { CompanyComponent };
